export default "__VITE_ASSET__Cnwcj8uW__"